exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Qrxu{position:relative}.Bi16B{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._2N9TP{position:relative;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._2VZLo{margin-bottom:20px}._2N9TP:hover{cursor:pointer;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_2Qrxu",
	"row": "Bi16B",
	"advert": "_2N9TP",
	"multirow": "_2VZLo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/InlineAdvertsBlock/InlineAdvertsBlock.css
// module id = 1872
// module chunks = 20 21 23 33 38